
import { defineComponent } from 'vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';

export default defineComponent({
  name: 'PortalIntro',

  components: { CustomButton },

  data: () => ({
    show: true,
  }),
});
